import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useTranslation } from '../context/LanguageContext';

const { FiUser, FiPlus, FiTrash2 } = FiIcons;

const ContactForm = ({ onAddContact, contacts, onRemoveContact }) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('+63');
  const { t } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();
    const digitsOnly = phone.replace(/\D/g, '');
    if (name.trim() && digitsOnly.length === 12) {
      onAddContact({ name: name.trim(), phone: phone.trim() });
      setName('');
      setPhone('+63');
    }
  };

  const handlePhoneChange = (e) => {
    let val = e.target.value;
    if (!val.startsWith('+63')) {
      val = '+63' + val.replace(/^\+?63?/, '').replace(/\D/g, '');
    }
    const digits = val.slice(3).replace(/\D/g, '').slice(0, 10);
    let formatted = '+63';
    if (digits.length > 0) formatted += ' ' + digits.slice(0, 3);
    if (digits.length > 3) formatted += ' ' + digits.slice(3, 6);
    if (digits.length > 6) formatted += ' ' + digits.slice(6, 10);
    setPhone(formatted.trim());
  };

  const digitsCount = phone.replace(/\D/g, '').slice(2).length;

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-800 mb-6 flex items-center space-x-2">
        <SafeIcon icon={FiUser} className="text-indigo-600" /> <span>{t('manage_contacts')}</span>
      </h2>
      <form onSubmit={handleSubmit} className="bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-4 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">{t('contact_name')}</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg outline-none" required />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">{t('phone_number')}</label>
            <div className="flex space-x-2">
              <div className="relative flex-1">
                <input type="tel" value={phone} onChange={handlePhoneChange} className={`w-full px-3 py-2 border rounded-lg focus:ring-2 outline-none ${digitsCount === 10 ? 'border-green-500' : 'border-gray-300'}`} required />
                <div className="absolute right-3 top-2.5 flex items-center space-x-1">
                  <span className={`text-[10px] font-bold ${digitsCount === 10 ? 'text-green-600' : 'text-gray-400'}`}>{digitsCount}/10</span>
                </div>
              </div>
              <button type="submit" disabled={digitsCount !== 10 || !name.trim()} className="px-4 py-2 bg-indigo-600 text-white rounded-lg disabled:opacity-50">
                <SafeIcon icon={FiPlus} />
              </button>
            </div>
          </div>
        </div>
      </form>
      {contacts.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {contacts.map((contact) => (
            <div key={contact.id} className="flex items-center justify-between bg-white border border-gray-100 rounded-lg p-3 shadow-sm">
              <div className="truncate">
                <p className="font-medium text-gray-800 text-sm truncate">{contact.name}</p>
                <p className="text-[10px] text-gray-500">{contact.phone}</p>
              </div>
              <button onClick={() => onRemoveContact(contact.id)} className="text-gray-300 hover:text-red-500 transition-colors">
                <SafeIcon icon={FiTrash2} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContactForm;